module.exports = __webpack_public_path__ + "static/media/bts_boots_170817_012_small.0c73d765.jpg";